import React, { useEffect, useRef} from 'react';
import { useDispatch, useSelector} from "react-redux";
import { useLocation, useHistory  } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Icon from '@material-ui/core/Icon';
import Popper from '@material-ui/core/Popper';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Typography } from '@mui/material';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import { confmsg } from '../modules/msgboxstore';
import { isEmpty, isEnabled, ByteLeft } from '../modules/appLibrary';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import ActionIcon from '@mui/icons-material/DoneAll';

const theme = createTheme({
    typography: {
        subtitle1: {
            fontSize: 12,
            marginLeft: 15,
            color:'#888'
        },
    },
});

//---------------------------------------------------------------------
//  ステータスナビゲーション
//
//  type: List TAB
//  onStatusChange: Status Change callback
//  onMenuClick: Menu Click callback
//  existform: true:Entry Form有
//  saveas:undefined=My項目登録メニュ非表示
//  menu:拡張メニュ
//  suppressaction:抑止動作
//  mysave:My項目登録表示/非表示
//  list:true=List
//  entryonly:true:status切り替えボタンなし
//  usecondition:true:CONDITION使用
//  execute:LIST実行 callback
//  hiddencmd:Statusに対する非表示コマンド ex)[{status:"ENTRY FORM", cmd:"登録"}] cmd=primary
//---------------------------------------------------------------------
export default function StatusNav(props) {

    const modify = useSelector(state => state.form.modify);
    const entrylock = useSelector(state => state.form.entryformlock);
    const readonly = useSelector(state => state.form.readonly);
    const ctrls = useSelector(state => state.form.ctrls);
    const themestyle = useSelector(state => state.form.themestyle);
    const reports = useSelector(state => state.form.reports);
    const [open, setOpen] = React.useState(false);
    const [menuopen, setmenuOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
    const anchormenuRef = React.useRef(null);
    const [options, setoptions] = React.useState([]);
    const status = useSelector(state => state.form.status);
    const prestoragename = useSelector(state => state.form.prestoragename);
    const dispatch = useDispatch();
    const isViewStatus = status === 'VIEW';
    const hideConditionCancel = status === "CONDITION" && isEnabled(props.usecondition) && !isEnabled(props.conditioncancelenabled);
    const customEntryStatusEnabled = typeof props.entrystatusaction === "function";
    const statusSelectDisabled = (isEnabled(props.entryonly) && !customEntryStatusEnabled) || options.length === 0 || props.notshowstatus;
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        if (customEntryStatusEnabled) {
            const customOptions = typeof props.entrystatusoptions === "function"
                ? props.entrystatusoptions(status)
                : props.entrystatusoptions;
            setoptions(Array.isArray(customOptions) ? customOptions : []);
        } else if (status === 'VIEW' || status === 'CONDITION') {
            let option = [];
            let showcondition = status === 'VIEW' && isEnabled(props.usecondition);
            let showupdate = !IsSuppress("UPDATE");
            let showinsert = !IsSuppress("INSERT");
            let shownew = true;
            let showentry = true;
            if (!isEmpty(props.suppressaction)) {
                if (props.suppressaction.some(e => (e.type === props.type || e.type === "*") && e.action === "UPDATE")) showupdate = false;
                if (props.suppressaction.some(e => (e.type === props.type || e.type === "*") && e.action === "INSERT")) showinsert = false;
                if (props.suppressaction.some(e => (e.type === props.type || e.type === "*") && e.action === "NEW FORM")) shownew = false;
                if (props.suppressaction.some(e => (e.type === props.type || e.type === "*") && e.action === "ENTRY FORM")) showentry = false;
            }
            if (isEnabled(readonly)) {
                showupdate = false;
                showinsert = false;
            }
            if (showcondition) option.push('CONDITION');
            if (status === 'VIEW') {
                if (showupdate) option.push('UPDATE');
                if (showinsert) option.push('INSERT');
            } else {
                if (showinsert) option.push('INSERT');
            }
            if (props.existform) {
                if (!isEnabled(readonly)) {
                    if (!IsSuppress("NEW FORM") && shownew)
                        option.push('NEW FORM');
                }
                if (status === 'VIEW' && !IsSuppress('ENTRY FORM') && showentry) option.push('ENTRY FORM');
            }
            if (status === 'VIEW' && props.masonry && props.type === "0" && !IsSuppress("MASONRY")) {
                option.push('MASONRY');
            }
            if (status === "CONDITION" && !hideConditionCancel) option.push('CANCEL');
            setoptions(option);
        } else if (status === "ENTRY FORM" && !isEnabled(readonly)) {
            let option = ['CANCEL'];
            if (!IsSuppress("COPY")) option.push('COPY');
            if (!IsSuppress("NEW FORM")) option.push('NEW');
            setoptions(option);
        } else {
            if (isInsertOnly()) setoptions( []);
            else setoptions(hideConditionCancel ? [] : ['CANCEL']);
        }
    }, [status, props.type, readonly, ctrls, props.usecondition, props.conditioncancelenabled, hideConditionCancel, customEntryStatusEnabled, props.entrystatusoptions]);

    function IsSuppress(cmd) {
        switch (cmd) {
            case "UPDATE":
                cmd = "NAV1"; break;
            case "INSERT":
                cmd = "NAV2"; break;
            case "NEW FORM":
                if (!isEmpty(props.suppressaction)) {
                    if (props.suppressaction.some(e => (e.type === props.type || e.type === "*") && e.action === "NEW FORM")) return true;
                }
                cmd = ["NAV3","NAV4"]; break;
            case "ENTRY FORM":
                cmd = ["NAV7", "NAV4"]; break;
            case "MASONRY":
                cmd = "NAV5"; break;
            case "COPY":
                if (!isEmpty(props.suppressaction)) {
                    if (props.suppressaction.some(e => (e.type === props.type || e.type === "*") && e.action === "COPY FORM")) return true;
                }
                cmd = "NAV6"; break;
            default:
                break;
        }
        if (ctrls === "") return false;
        if (typeof cmd === "string") {
            if (ctrls.indexOf(cmd) === -1) return false;
            //分解してチェック
            let ctrlsAr = ctrls.split(',');
            return ctrlsAr.includes(cmd);
        }
        else {
            let ctrlsAr = ctrls.split(',');
            for (let i = 0; i < cmd.length; i++) {
                return ctrlsAr.includes(cmd[i]);
            }
            return false;
        }
    }
    function IsHide(cmd) {
        try {
            if (isEmpty(props.hiddencmd)) return false;
            return props.hiddencmd.some(e => e.status === status && e.cmd === cmd);
        } catch {  }
    }
    function isInsertOnly() {
        if (isEnabled(props.entryonly)) return false;

        let showupdate = !IsSuppress("UPDATE");
        let showinsert = !IsSuppress("INSERT");
        let shownew = true;
        let showentry = true;

        if (!isEmpty(props.suppressaction)) {
            if (props.suppressaction.some(e => e.type === props.type && e.action === "UPDATE")) showupdate = false;
            if (props.suppressaction.some(e => e.type === props.type && e.action === "INSERT")) showinsert = false;
            if (props.suppressaction.some(e => e.type === props.type && e.action === "NEW FORM")) shownew = false;
            if (props.suppressaction.some(e => e.type === props.type && e.action === "ENTRY FORM")) showentry = false;
        }
        if (isEnabled(readonly)) {
            showupdate = false;
            showinsert = false;
        }

        let options = [];
        if (showupdate) options.push("UPDATE");
        if (showinsert) options.push("INSERT");
        if (props.entryform) {
            if (!isEnabled(readonly)) {
                if (!IsSuppress("NEW FORM") && shownew) options.push("NEW FORM");
            }
            if (!IsSuppress("ENTRY FORM") && showentry) options.push("ENTRY FORM");
        }
        return options.length === 1 && options[0] === "INSERT";
    }


    function StatusClick(event, index) {
        if (customEntryStatusEnabled) {
            props.entrystatusaction(options[index], status);
            setOpen(false);
            return;
        }
        if (status === 'VIEW') {
            if (modify && options[index] === "INSERT") {
                dispatch(confmsg({ msg: "編集内容は破棄されます。よろしいですか?", cmd: () => confirm_OK(options[index]) }));
                setOpen(false);
                return;
            }
            props.onStatusChange('VIEW', options[index]);
        } else if (status === "ENTRY FORM" && options[index]==="COPY") {
            props.onStatusChange(status, 'COPY FORM');
        } else if (status === "ENTRY FORM" && options[index] === "NEW") {
            props.onStatusChange(status, 'NEW FORM');
        } else if (status === "COPY FORM") {    //copy →cancel
            if (modify) {
                dispatch(confmsg({ msg: "編集内容は破棄されます。よろしいですか?", cmd: () => confirm_OK('ENTRY FORM') }));
                setOpen(false);
                return;
            }
            props.onStatusChange(status, 'ENTRY FORM');
        } else if (status === "CONDITION") {
            props.onStatusChange(status, options[index] === "CANCEL" ? 'VIEW' : options[index]);
        } else {
            var newstatus = "VIEW";
            //ENTRY,NEW->CANCEL
            if (props.usecondition && (status === "ENTRY FORM" || status === "NEW FORM")) {
                if( LinkEntry()) {      //他画面からの遷移
                    newstatus = "CONDITION";
                    history.replace({               //１度だけ
                        ...location,
                        state: null,
                    });
                }
            }
            if (modify) {
                dispatch(confmsg({ msg: "編集内容は破棄されます。よろしいですか?", cmd: () => confirm_OK(newstatus) }));
                setOpen(false);
                return;
            }
            props.onStatusChange(status, newstatus);
        }
        setOpen(false);
    }
    //他画面からのENTRY遷移だったか
    function LinkEntry() {
        if (isEmpty(location.state)) return false;
        return location.state.status !== 'LIST';
    }
    function confirm_OK(newstatus) {
        props.onStatusChange(status, newstatus);
    }

    function OpenMenu() {
        if (status === "CONDITION" && !isEmpty(props.execute)) {
            props.execute();
            return;
        }
        setOpen(false);
        setmenuOpen((prevOpen) => !prevOpen);
    }

    function MenuClick(menu) {
        setmenuOpen(false);
        props.onMenuClick(menu)
    }
    const prestrnamemenu = "前回使用した保存データを開く：" + prestoragename;

    function ReportsMenu() {
        var menu = reports.filter(e => e.status === "2" || (isViewStatus && e.status === "0") || (status === "ENTRY FORM" && e.status === "1"));
        if (isViewStatus) {
            menu = menu.filter(e => e.tab === '' || e.tab === props.type);
        }
        if (menu.length === 0) return null;
        return (
            <React.Fragment>
                {status === "ENTRY FORM" ? <Divider />:null}
                {menu.map(item => (
                        <ListItem button onClick={() => MenuClick(item.id)}>
                            <ListItemIcon><Icon>print</Icon></ListItemIcon>
                            <ListItemText primary={item.name}  />
                        </ListItem>
                ))}
                <Divider />
            </React.Fragment>
        );
    }
    const ExMenu = ({ menu }) => {
        if (IsSuppress("UP")) {
            menu = menu.filter(e => e.menuid !== "upload" && e.menuid !== "formupload")
        }
        return (
            <React.Fragment>
                <Divider />
                {menu.map(item => (
                    ByteLeft(item.menuid,3) === 'sep' ?
                        <Divider /> :
                        <ListItem button onClick={() => MenuClick(item.menuid)}>
                            {item.icon !== '' ?
                                <ListItemIcon><Icon>{item.icon}</Icon></ListItemIcon>
                                :
                                <ListItemIcon><ActionIcon/></ListItemIcon>
                            }
                            <ListItemText primary={item.label} title={item.title} />
                        </ListItem>
                ))}

            </React.Fragment>
        );
    }
    function MenuItemList() {
        let menu = [];
        if (!isEmpty(props.menu)) {
            menu = props.menu.filter(e => e.status === status || (status === "CONDITION" && e.status === "VIEW"))
        }
        switch (status) {
            case "VIEW":
                return <List component="nav" style={{ width: 300 }}>
                    {props.saveas === undefined ? null :
                        <React.Fragment>
                        {isEnabled(props.mysave) ?
                            <React.Fragment>
                            <ListItem button onClick={() => MenuClick('save')}>
                                <ListItemIcon><Icon>save</Icon></ListItemIcon>
                                <ListItemText primary="My項目登録" />
                            </ListItem>
                            <Divider />
                            </React.Fragment>
                        : null}
                        {IsSuppress("STORAGE") ? null :
                            <React.Fragment>
                            <ListItem button onClick={() => MenuClick('saveas')}>
                                <ListItemIcon><Icon>save_as</Icon></ListItemIcon>
                                <ListItemText primary="名前を付けて保存" />
                            </ListItem>
                            <ListItem button onClick={() => MenuClick('stropen')}>
                                <ListItemIcon><Icon>file_open</Icon></ListItemIcon>
                                <ListItemText primary="保存データを開く" />
                            </ListItem>
                            {prestoragename === ""?null:
                                <ListItem button onClick={() => MenuClick('stropen2')}>
                                    <ListItemIcon><Icon>file_open</Icon></ListItemIcon>
                                    <ListItemText primary={prestrnamemenu} />
                                </ListItem>
                            }
                            <Divider />
                            </React.Fragment>
                        }
                        </React.Fragment>
                    }
                    <ListItem button onClick={() => MenuClick('reload')}>
                        <ListItemIcon><Icon>refresh</Icon></ListItemIcon>
                        <ListItemText primary="再表示" />
                    </ListItem>
                    <Divider />
                    {reports.length === 0 ? null : <ReportsMenu />}
                    {menu.length === 0 ? null : <ExMenu menu={menu} />}
                </List>
            case "UPDATE":
                return <List component="nav" style={{ width: 300 }}>
                    {(IsSuppress("UPSAVE") || IsHide("登録") )? null :
                        <ListItem button onClick={() => MenuClick('save')}>
                            <ListItemIcon><Icon>save</Icon></ListItemIcon>
                            <ListItemText primary="登録" />
                        </ListItem>
                    }
                    {(IsSuppress("DEL1") || IsHide("削除") )?null:
                        <ListItem button onClick={() => MenuClick('delete')}>
                            <ListItemIcon><Icon>delete</Icon></ListItemIcon>
                            <ListItemText primary="削除（選択行データ）" />
                        </ListItem>
                    }
                    <Divider />
                    {IsHide("Excel") ? null :
                        <ListItem button onClick={() => MenuClick('excel')}>
                            <ListItemIcon><Icon>file_download</Icon></ListItemIcon>
                            <ListItemText primary="Excel" title="現在のシート内容をExcelに出力します" />
                        </ListItem>
                    }
                    {IsSuppress("UPSAVE") || IsSuppress("UPIMPORT") || IsHide("データ取込") ? null :
                        <ListItem button onClick={() => MenuClick('import')}>
                            <ListItemIcon><Icon>post_add</Icon></ListItemIcon>
                            <ListItemText primary="データ取込" title="ExcelまたはCSVファイルをシートに取込ます" />
                        </ListItem>
                    }
                    {menu.length === 0 ? null : <ExMenu menu={menu} />}
                </List>
            case "INSERT":
                return <List component="nav" style={{ width: 300 }}>
                    <ListItem button onClick={() => MenuClick('save')}>
                        <ListItemIcon><Icon>save</Icon></ListItemIcon>
                        <ListItemText primary="登録" />
                    </ListItem>
                    <Divider />
                    <ListItem button onClick={() => MenuClick('clear')}>
                        <ListItemIcon><Icon>content_copy</Icon></ListItemIcon>
                        <ListItemText primary="シートクリア" />
                    </ListItem>
                    <Divider />
                    <ListItem button onClick={() => MenuClick('excel')}>
                        <ListItemIcon><Icon>file_download</Icon></ListItemIcon>
                        <ListItemText primary="Excel" title="現在のシート内容をExcelに出力します" />
                    </ListItem>
                    {IsSuppress("INSIMPORT") ? null :
                        <ListItem button onClick={() => MenuClick('import')}>
                            <ListItemIcon><Icon>post_add</Icon></ListItemIcon>
                            <ListItemText primary="データ取込" title="ExcelまたはCSVファイルをシートに取込ます" />
                        </ListItem>
                    }
                    {menu.length === 0 ? null : <ExMenu menu={menu} />}
                </List>
            case "NEW FORM":
                return <List component="nav" style={{ width: 300 }}>
                    {IsHide("登録") ? null :
                        <React.Fragment>
                            <ListItem button onClick={() => MenuClick('save')}>
                                <ListItemIcon><Icon>save</Icon></ListItemIcon>
                                <ListItemText primary="登録" />
                            </ListItem>
                            <Divider />
                        </React.Fragment>
                    }
                    {IsHide("フィールドクリア") ? null :
                        <ListItem button onClick={() => MenuClick('clear')}>
                            <ListItemIcon><Icon>content_copy</Icon></ListItemIcon>
                            <ListItemText primary="フィールドクリア" />
                        </ListItem>
                    }
                    {menu.length === 0 ? null : <ExMenu menu={menu} />}
                </List>
            case "COPY FORM":
                return <List component="nav" style={{ width: 300 }}>
                    {IsHide("登録") ? null :
                        <ListItem button onClick={() => MenuClick('save')}>
                            <ListItemIcon><Icon>save</Icon></ListItemIcon>
                            <ListItemText primary="登録" />
                        </ListItem>
                    }
                    {menu.length === 0 ? null : <ExMenu menu={menu} />}
                </List>

            case "ENTRY FORM":
                return <List component="nav" style={{ width: 300 }}>
                    {readonly === true ? null :
                        <React.Fragment>
                            {(IsSuppress("SAVE") || IsHide("登録")) ? null :
                                <ListItem button onClick={() => MenuClick('save')}>
                                    <ListItemIcon><Icon>save</Icon></ListItemIcon>
                                    <ListItemText primary="登録" />
                                </ListItem>
                            }
                            {(IsSuppress("DEL2") || IsHide("削除")) ? null :
                                <ListItem button onClick={() => MenuClick('delete')}>
                                    <ListItemIcon><Icon>delete</Icon></ListItemIcon>
                                    <ListItemText primary="削除" />
                                </ListItem>
                            }
                            <Divider />
                        </React.Fragment>
                    }
                    {IsHide("再表示") ? null :
                        <ListItem button onClick={() => MenuClick('reload')}>
                            <ListItemIcon><Icon>refresh</Icon></ListItemIcon>
                            <ListItemText primary="再表示" />
                        </ListItem>
                    }

                    {reports.length === 0 ? null : <ReportsMenu />}
                    {menu.length === 0 ? null : <ExMenu menu={menu} />}
                </List>
            default:
                return null;
        }
    }

    function changeStatus(){
        setmenuOpen(false);
        setOpen((prevOpen) => !prevOpen);
    }

    function CloseStatus(event){
        if (anchorRef.current && anchorRef.current.contains(event.target)) 
            return;
        setOpen(false);
    }
    function CloseMenu(event) {
        if (anchormenuRef.current && anchormenuRef.current.contains(event.target))
            return;
        setmenuOpen(false);
    }

    function MenuName(option) {
        switch (option) {
            case "CONDITION":
                return "- 条件";
            case "INSERT":
                return "- 追加";
            case "UPDATE":
                return "- 更新";
            case "NEW FORM":
                return "- 新規";
            case "ENTRY FORM":
                return "- 編集";
            case "COPY FORM":
                return "- 複写";
            case "MASONRY":
                return "- 画像";
            default:
                return "";
        }
    }

    return (
        <Grid container direction="column">
            <Grid item xs={12}>
                <ButtonGroup variant="contained" ref={anchormenuRef}>
                    <Button
                        startIcon={status === "ENTRY FORM" && entrylock ? <Icon>lock</Icon> : <Icon>menu</Icon>}
                        onClick={OpenMenu}
                        style={{
                            width: 150, backgroundColor: themestyle.body.back === '#F8F8F8' ? themestyle.maincolor : "#F2F0ED",
                            color: status === "ENTRY FORM" && entrylock ? '#A36452' : themestyle.body.back === '#F8F8F8' ? '#FFF':'#333'
                        }}
                    >
                    {status}
                    </Button>
                        {
                            props.list ?
                                <Button
                                    size="small"
                                    title="再表示"
                                    onClick={() => MenuClick('reload')}
                                    style={{ backgroundColor: themestyle.body.accentback, color: themestyle.maincolor }}
                                >
                                    <Icon>play_arrow</Icon>
                                </Button>
                                :
                                <Button
                                    size="small"
                                    aria-controls={open ? 'split-button-menu' : undefined}
                                    aria-expanded={open ? 'true' : undefined}
                                    aria-label="status navigation"
                                    aria-haspopup="menu"
                                    ref={anchorRef}
                                    onClick={changeStatus}
                                    style={{ backgroundColor: '#F2F0ED', color: '#333' }}
                                    disabled={statusSelectDisabled}
                                >
                                {statusSelectDisabled ? null : <Icon>expand_more</Icon>}
                                </Button>

                        }
                </ButtonGroup>


                    <Popper open={menuopen} anchorEl={anchormenuRef.current} role={undefined} placement={'bottom-start'} style={{ zIndex: 10 }} transition>
                        {({ TransitionProps, placement }) => (
                            <Grow
                                {...TransitionProps}
                                style={{
                                    transformOrigin: 'center top',
                                }}
                            >
                                <ClickAwayListener onClickAway={CloseMenu}>
                                    <Paper>
                                        <MenuItemList />
                                    </Paper>
                                </ClickAwayListener>
                            </Grow>
                        )}
                    </Popper>

                {isEnabled(props.notshowstatus) ? null :
                    <Popper open={open} anchorEl={anchorRef.current} role={undefined} placement={status === 'MASONRY' ? 'right-end' : 'bottom-start'} style={{ zIndex: 10 }} transition>
                        {({ TransitionProps, placement }) => (
                            <Grow
                                {...TransitionProps}
                                style={{
                                    transformOrigin: 'center top',
                                }}
                            >
                                <Paper>
                                    <ClickAwayListener onClickAway={CloseStatus}>
                                        <MenuList id="split-button-menu">
                                            {options.map((option, index) => (
                                                <MenuItem
                                                    key={option}
                                                    onClick={(event) => StatusClick(event, index)}
                                                >
                                                    <ListItemText>{option}</ListItemText>
                                                    <ThemeProvider theme={theme}>
                                                        <Typography align="right" variant="subtitle1">{MenuName(option)}</Typography >
                                                    </ThemeProvider>
                                                </MenuItem>
                                            ))}
                                        </MenuList>
                                    </ClickAwayListener>
                                </Paper>
                            </Grow>
                        )}
                    </Popper>
                }
            </Grid>
        </Grid>
    );
}
